  export const scrollToTop = () => {
    window.scrollTo({ top: 0 });
  };

  export const isValidPhoneNumber = (phone) => {
  const digitsOnly = phone.replace(/\D/g, ""); // remove non-digit characters
  return digitsOnly.length >= 10 && digitsOnly.length <= 15;
};


  
export const formatDate = (isoDateStr) => {
  const date = new Date(isoDateStr);

  const day = date.getDate(); // Day of the month
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


export function formatTime(dateString) {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12; // convert to 12-hour format

  return `${hours}:${minutes}${ampm}`;
}

export function isValidURL(url) {
  const pattern = new RegExp(
    /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
    "i"
  );

  try {
    const formattedUrl = url.startsWith("http") ? url : `https://${url}`;
    const parsed = new URL(formattedUrl);
    return pattern.test(parsed.href);
  } catch {
    return false;
  }
}



export function validatePassword(pwd) {
  if (!pwd) return { valid: false, message: "Password is required" };

  // At least 8 characters, 1 uppercase, 1 lowercase, 1 digit, 1 special character, no spaces
  const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>_\-\\[\]])(?!.*\s).{8,}$/;

  if (!regex.test(pwd)) {
    return {
      valid: false,
      message:
        "Password must be at least 8 characters long and include uppercase, lowercase, number, special character, and no spaces",
    };
  }

  return { valid: true };
}
